import React from 'react'
import DataToken from '../components/DataToken'
import page from '~utils/page'
import { TOKEN } from '~shared/Nav'
import Head from '~shared/Head'

// eslint-disable-next-line import/no-unused-modules
export default page(DataToken, {
    highlight: TOKEN,
    streamrClient: true,
    headComponent: (
        <Head
            mediaDescription="The DATA token"
            // eslint-disable-next-line max-len
            description="The DATA token is an ERC-20 token used for project governance, to incentivise the Network participants, and to delegate stake on Streamr nodes."
        />
    ),
})
